import { h, Component } from 'preact';
import {Form, Container} from 'components/elements' 
import {connect} from 'react-redux'
import {PageActions} from 'actions'
import {FAHome, FACalendar, FAUser, FAFile, FACheckSquare} from 'components/elements/FontAwesome'
import style from './style.less'

@Form
@connect((state)=>({
	...state
}))
export default class Steps extends Component {
	constructor(){
        super()
        this.changePage = this.changePage.bind(this)
        this.getContainerClass = this.getContainerClass.bind(this)
    }
    
    changePage(page){
        if(this.props.completedPages.includes(page)){
            PageActions.set(page)
        }
    }

    getContainerClass(page){
        let classes = [style.stepOuter]
        if(this.props.page == page){
            classes.push(style.current)
        } else if(this.props.completedPages.includes(page)){
            classes.push(style.completed)
        }
        if(page == 'sessions'){
            classes.push(style.left)
        }
        return classes.join(' ')
    }

	render(){
        if(this.props.page == 'receipt'){
            return ''
        }
		return (
            <div class={style.stepsContainer} style={{maxWidth: this.props.config.type == 'registration'? '500px': '700px'}}>
                <div class={this.getContainerClass('sessions')} onClick={this.changePage.bind(null,'sessions')}>
                    <FAHome class={style.step} />
                </div>
                {this.props.config.type != 'registration' && 
                    <div class={this.getContainerClass('timeSlots')} onClick={this.changePage.bind(null,'timeSlots')} style={{width: '25%'}}>
                        <div class={style.connector}></div>
                        <FACalendar class={style.step} />
                    </div>
                }
                <div class={this.getContainerClass('collectInformation')} onClick={this.changePage.bind(null,'collectInformation')} style={{width: this.props.config.type == 'registration'? '33%': '25%'}}>
                    <div class={style.connector}></div>
                    <FAUser class={style.step} />
                </div>
                <div class={this.getContainerClass('confirmation')} onClick={this.changePage.bind(null,'confirmation')} style={{width: this.props.config.type == 'registration'? '33%': '25%'}}>
                    <div class={style.connector}></div>
                    <FAFile class={style.step} />
                </div>
                <div class={this.getContainerClass('receipt')} style={{width: this.props.config.type == 'registration' ? '33%': '25%'}}>
                    <div class={style.connector}></div>
                    <FACheckSquare class={style.step} />
                </div>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/Steps/index.js